import { DoodleArrowCurved, DoodleClock, FloatingDoodle } from "./Doodles";
import { useInViewOnce } from "@/hooks/useInViewOnce";
import { useLanguage } from "@/contexts/LanguageContext";

const HowItWorksSection = () => {
  const { ref, isInView } = useInViewOnce();
  const { t } = useLanguage();

  const steps = [
    { number: "01", title: t("landing.how_step1"), description: t("landing.how_step1_desc") },
    { number: "02", title: t("landing.how_step2"), description: t("landing.how_step2_desc") },
    { number: "03", title: t("landing.how_step3"), description: t("landing.how_step3_desc") },
    { number: "04", title: t("landing.how_step4"), description: t("landing.how_step4_desc") },
  ];

  return (
    <section id="how-it-works" className="relative py-24 bg-secondary/50 overflow-hidden">
      {/* Doodle decorations */}
      <div className="pointer-events-none absolute inset-0">
        <FloatingDoodle delay={0} duration={5} y={8}>
          <DoodleClock className="absolute top-16 left-[6%] text-accent/20" />
        </FloatingDoodle>
        <DoodleArrowCurved className="absolute bottom-16 right-[10%] text-primary/10" />
      </div>

      <div className="container relative mx-auto px-4">
        <div className="mx-auto max-w-2xl text-center">
          <span className="text-sm font-semibold uppercase tracking-wider text-primary">{t("landing.how_label")}</span>
          <h2 className="mt-3 text-4xl font-bold text-foreground">
            {t("landing.how_title")}
          </h2>
        </div>

        <div ref={ref} className="mx-auto mt-16 grid max-w-4xl gap-8 grid-cols-2 md:grid-cols-4 md:gap-0">
          {steps.map((step, i) => (
            <div
              key={step.number}
              className="relative flex flex-col items-center text-center px-4"
              style={{
                opacity: isInView ? 1 : 0,
                transform: isInView ? "translateY(0)" : "translateY(20px)",
                transition: `opacity 0.4s ease-out ${i * 0.1}s, transform 0.4s ease-out ${i * 0.1}s`,
              }}
            >
              {i < steps.length - 1 && (
                <div className="absolute top-6 left-[calc(50%+24px)] hidden h-0.5 w-[calc(100%-48px)] bg-border md:block" />
              )}
              <div className="relative z-10 mb-4 flex h-12 w-12 items-center justify-center rounded-full bg-gradient-primary text-sm font-bold text-primary-foreground">
                {step.number}
              </div>
              <h3 className="text-base font-semibold text-foreground">{step.title}</h3>
              <p className="mt-2 text-sm text-muted-foreground">{step.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default HowItWorksSection;
